import { useMemo } from 'react';
import { isDateTime } from 'customer-data-objects/property/PropertyIdentifier';
import { BreezeSingleStarIcon } from 'foundations-assets';
import { Spacer } from 'foundations-components/components/Spacer';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAuth } from '../../auth/context/AuthContext';
import { shouldRightAlignProperty } from '../../utils/shouldRightAlignProperty';
import TruncateDiv from '../TruncateDiv';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FLEX_ASSOCIATIONS_GATE = 'flexible-associations';
const PropertyHeaderContent = ({
  propertyDefinition,
  isSmartProperty = false
}) => {
  const {
    hasGate
  } = useAuth();
  const content = useMemo(() => {
    if (propertyDefinition.name === 'associatedcompanyid') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: hasGate(FLEX_ASSOCIATIONS_GATE) ? 'datatable.associatedCompanyId.flexibleAssociationsHeader' : 'datatable.associatedCompanyId.standardHeader'
      });
    }
    const isRelativeTimeProperty = propertyDefinition.dateDisplayHint === 'time_since' || propertyDefinition.dateDisplayHint === 'time_until';
    if (isDateTime(propertyDefinition) && !isRelativeTimeProperty) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.dateTimeCell.header",
        options: {
          label: propertyDefinition.label,
          timezone: I18n.moment.userTz().format('z')
        }
      });
    }
    return propertyDefinition.label;
  }, [hasGate, propertyDefinition]);
  return /*#__PURE__*/_jsxs(TruncateDiv, {
    rightAligned: shouldRightAlignProperty(propertyDefinition),
    children: [isSmartProperty ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(BreezeSingleStarIcon, {
        alignWithText: true,
        color: "icon-core-subtle"
      }), /*#__PURE__*/_jsx(Spacer, {
        display: "inline-block",
        space: "100"
      })]
    }) : null, content]
  });
};
export default PropertyHeaderContent;